module.exports = __webpack_public_path__ + "2b4f4bb2219a52f42918fc27850ae9fb.pdf";